import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Step } from '../../../../../components/Step';
import Select from 'src/shared/components/Form/Select';
import { useTranslation } from 'react-i18next';
import { type FactorialTeam, type FactorialParamsResponse } from 'src/shared/api/integrations/factorial';
import { Checkbox, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { SELECT_ALL_VALUE } from 'src/modules/Settings/Integrations/pages/components/integrations2.0/Factorial/components/AfterConnection/components/Step4/hooks';
import { useStep3 } from 'src/modules/Settings/Integrations/pages/components/integrations2.0/Factorial/components/AfterConnection/components/Step3/hooks';
import { formatMultipleSelected } from 'src/modules/Settings/Integrations/pages/components/integrations2.0/Factorial/utils';

type Step3Props = {
  data: FactorialParamsResponse | undefined;
};

export const Step3 = ({ data }: Step3Props) => {
  const { t } = useTranslation('settings');
  const { handleChange, dataToSelect, values } = useStep3(data);

  if (!data) {
    return null;
  }
  return (
    <Step
      title={`${t('integrations.step')} 3`}
      subtitle={`${t('integrations.factorial.select the teams you want to synchronise')}:`}
      Icon={PeopleAltIcon}
    >
      <Select
        multiple
        sx={{ width: '300px' }}
        label={t('integrations.factorial.select teams')}
        name="teams"
        renderValue={formatMultipleSelected(dataToSelect)}
        onChange={handleChange}
      >
        <MenuItem value={SELECT_ALL_VALUE}>
          <ListItemIcon>
            <Checkbox checked={dataToSelect?.length === values?.teams?.length} />
          </ListItemIcon>
          <ListItemText primary={t('select all', { ns: 'common' })} />
        </MenuItem>
        {dataToSelect.map(({ label, value }) => {
          return (
            <MenuItem key={label} value={value}>
              <Checkbox key={values?.teams?.includes(value)} checked={values?.teams?.includes(value)} />
              <ListItemText primary={label} />
            </MenuItem>
          );
        })}
      </Select>
    </Step>
  );
};
